var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check",class:{
        defaultCheck: _vm.calcClass === 'defaultCheck',
        greenCheck: _vm.calcClass === 'greenCheck',
        redCheck: _vm.calcClass === 'redCheck',
    },on:{"click":_vm.clickHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }